import _defineProperty from "@babel/runtime/helpers/defineProperty";
// https://tc39.es/ecma262/#sec-execution-contexts
export class ExecutionContext {
  constructor() {
    _defineProperty(this, "VariableEnvironment", void 0);
    _defineProperty(this, "LexicalEnvironment", void 0);
    _defineProperty(this, "Function", void 0);
  }
}
// https://tc39.es/ecma262/#sec-environment-records
export class EnvironmentRecord {
  constructor(outer) {
    _defineProperty(this, "OuterEnv", void 0);
    _defineProperty(this, "bindingMap", new Map());
    this.OuterEnv = outer;
  }
  HasBinding(name) {
    return this.bindingMap.has(name);
  }
  CreateMutableBinding(name, deletable) {
    // Assert: binding does not exist.
    this.bindingMap.set(name, {
      mutable: true,
      deletable
    });
    return NormalCompletion(undefined);
  }

  /**
   * Create an immutable binding.
   *
   * @param name - The binding name.
   * @param strict - For named function expressions, strict is false, otherwise it's true.
   * @returns CompletionRecord.
   */
  CreateImmutableBinding(name, strict) {
    // Assert: binding does not exist.
    this.bindingMap.set(name, {
      strict
    });
    return NormalCompletion(undefined);
  }
  InitializeBinding(name, value) {
    var binding = this.bindingMap.get(name);
    // Assert: binding exists and uninitialized.
    Object.assign(binding, {
      initialized: true,
      value
    });
    return NormalCompletion(undefined);
  }

  /**
   * Update a mutable binding value, including function declarations.
   *
   * @param name - The binding name.
   * @param value - The binding value.
   * @param strict - For functions, strict is always false, otherwise it depends on strict-mode.
   * @returns
   */
  SetMutableBinding(name, value, strict) {
    var binding = this.bindingMap.get(name);
    // Assert: binding exists.
    if (!binding.initialized) {
      throw new ReferenceError("".concat(name, " is not initialized"));
    } else if (binding.mutable) {
      binding.value = value;
    } else {
      throw new TypeError("Assignment to constant variable");
    }
    return NormalCompletion(undefined);
  }
  GetBindingValue(name, strict) {
    var binding = this.bindingMap.get(name);
    // Assert: binding exists.
    if (!binding.initialized) {
      throw new ReferenceError("".concat(name, " is not initialized"));
    }
    return binding.value;
  }
}
export class DeclarativeEnvironment extends EnvironmentRecord {}
export class FunctionEnvironment extends EnvironmentRecord {}
export var SourceNode = Symbol.for("SourceNode");
export var FormalParameters = Symbol.for("FormalParameters");
export var ECMAScriptCode = Symbol.for("ECMAScriptCode");
export var Environment = Symbol.for("Environment");
export var IsConstructor = Symbol.for("IsConstructor");
// https://tc39.es/ecma262/#sec-reference-record-specification-type
export class ReferenceRecord {
  /** Whether the reference is in strict mode. */

  constructor(base, referenceName, strict) {
    _defineProperty(this, "Base", void 0);
    _defineProperty(this, "ReferenceName", void 0);
    _defineProperty(this, "Strict", void 0);
    this.Base = base;
    this.ReferenceName = referenceName;
    this.Strict = strict;
  }
}

// https://tc39.es/ecma262/#sec-completion-record-specification-type
export class CompletionRecord {
  constructor(type, value) {
    _defineProperty(this, "Type", void 0);
    _defineProperty(this, "Value", void 0);
    this.Type = type;
    this.Value = value;
  }
}
// https://tc39.es/ecma262/#sec-normalcompletion
export function NormalCompletion(value) {
  return new CompletionRecord("normal", value);
}
export var Empty = Symbol("empty completion");
//# sourceMappingURL=ExecutionContext.js.map